export const DEPOSIT_STEP_PW = `pending-withdraw`;
export const DEPOSIT_STEP_BONUS = `bonus`;
export const DEPOSIT_STEP_METHODS = `deposit-method`;
export const DEPOSIT_STEP_AMOUNT = `deposit-amount`;
export const DEPOSIT_STEP_EXECUTE_DEPOSIT = `execute-deposit`;
export const PAYMENT_METHOD = `payment-method`;
export const METHOD_TEMPLATE = `method-template`;
export const NEXT_STEP = `NEXT`;
export const PREV_STEP = `BACK`;
export const SWISH = 'SWISH';
export const API_IDLE = `idle`;
export const API_LOADING = `pending`;
export const API_SUCCESS = `success`;
export const API_ERROR = `error`;

export const steps = {
	DEPOSIT_STEP_PW,
	DEPOSIT_STEP_BONUS,
	DEPOSIT_STEP_METHODS,
	DEPOSIT_STEP_AMOUNT,
	DEPOSIT_STEP_EXECUTE_DEPOSIT
};

// Credit-card constants
export const CC_CN = `cn`;
export const CC_CVV = `cvv`;
export const CC_YEAR = `vy`;
export const CC_MONTH = `vm`;

export const paymentBetsQuery = 'DEPOSIT';
